﻿import Vue from "vue";
import common from "../../common";
import SearchBox_ from "../../core/SearchBox";
import context_ from "../context";
import SearchBoxExtensionVue_ from "../vue/SearchBoxExtensionVue";

declare function require(module: string): unknown;
const context = require("../context") as typeof context_;
// const SearchBox = require("../../core/SearchBox") as SearchBox_;
// const SearchBoxExtensionVue = require("../vue/SearchBoxExtensionVue");

//const jsClasses = require("../../../js/jsClasses") as any;

interface ISettings {
    /** Valeur de l'attribut HTML "id" du module Vuejs */
    vueElId: string;
    /** Determine si ce web component doit etre ajoute dans la liste "main.context.components" correspondant aux components loades dans la page courrante. 
     * Default: TRUE */
    appendToContextualComponents?: boolean;
    searchBox: SearchBox_;
    preconfiguredFilters: common.ISearchBoxPreconfiguredFiltersSettings;
}

class DefaultSearchBoxExtension implements common.IWebComponent {

    private _isInit = false;
    private _vue = null as SearchBoxExtensionVue_ | null;
    private _vueElId?: string;
    private _searchBox?: SearchBox_;
    private _clearTermsOnPreconfiguredFiltersChange = false;

    init(s: ISettings) {
        if (this._isInit)
            return;
        this._isInit = true;

        // configuration
        s.preconfiguredFilters = s.preconfiguredFilters || {} as common.ISearchBoxPreconfiguredFiltersSettings;

        this._vueElId = s.vueElId || (() => { throw "La propriété 'settings.vueElId' est requise."; })();
        this._clearTermsOnPreconfiguredFiltersChange = s.preconfiguredFilters.clearTermsOnApply === true;
        this._searchBox = s.searchBox || (() => { throw "La propriété 'settings.searchBox' est requise."; })();
        this._searchBox.setOnFetchingPreconfiguredFiltersCallback(preconfiguredFilters => {
            this.onFetchingPreconfiguredFilters(preconfiguredFilters);
        });

        this.setupVue(s);

        if (s.appendToContextualComponents !== false)
            context.components.add(this);

        return this;
    }

    private setupVue(s: ISettings) {

        Vue.prototype.$initialData = {
            vueElId: this._vueElId,
            preconfiguredFilters: s.preconfiguredFilters.filters || [] as common.ISearchBoxPreconfiguredFilters[]
        };

        this._vue = new SearchBoxExtensionVue_().setOnPreconfiguredFiltersClickCallback(filters => {
            this.onPreconfiguredFiltersClick(filters);
        });
    }

    private onFetchingPreconfiguredFilters(preconfiguredFilters: common.ISearchBoxPreconfiguredFilters[]) {
        this._vue?.setPreconfiguredFilters(preconfiguredFilters);
    }

    private onPreconfiguredFiltersClick(filters: common.ISearchBoxFilter[]) {
        if (this._clearTermsOnPreconfiguredFiltersChange)
            this._searchBox?.clearTerms();
        this._vue?.$nextTick(() => {
            this._searchBox?.setFilters(filters);
        });
    }
}

export = DefaultSearchBoxExtension;